import { useEffect, useState } from 'react'

import { useLazyQuery } from '@apollo/client'

import { gql } from '@web/federation/gql'
import { Coordinate } from '@web/federation/gql/graphql'
import useGetCurrentGeoLocation, {
  currentGeolocationLoadingVar,
} from '@web/pages/v5/libs/location/useGetCurrentGeoLocation'

const CurrentLocationAddressQuery = gql(`
  query currentLocation {
    currentLocation {
      fullAddress
      shortAddress
    }
  }
`)

interface Props {
  lilsCode: string
  allowToGetLocation: boolean
}

export const useCurrentLocation = ({ lilsCode, allowToGetLocation }: Props) => {
  const [coordinate, setCoordinate] = useState<Coordinate | null>(null)
  const [needToGet, setNeedToGet] = useState(true)
  const currentGeolocationLoading = currentGeolocationLoadingVar()
  const getCurrentGeoLocation = useGetCurrentGeoLocation()

  const refetchCurrentLocation = () => {
    setNeedToGet(true)
  }

  const [getCurrentLocationAddressQuery, { error, data, loading }] = useLazyQuery(CurrentLocationAddressQuery)

  useEffect(() => {
    if (allowToGetLocation && needToGet) {
      getCurrentGeoLocation(lilsCode).then(geoLocation => {
        if (!geoLocation) {
          setNeedToGet(false)
          return
        }
        setCoordinate(geoLocation)
        getCurrentLocationAddressQuery({
          context: {
            headers: {
              Geolocation: `${geoLocation.latitude},${geoLocation.longitude}`,
            },
          },
        })
        setNeedToGet(false)
      })
    }
  }, [needToGet])

  const shortAddress = data?.currentLocation?.shortAddress

  return {
    loading: currentGeolocationLoading || loading,
    error,
    shortAddress,
    coordinate,
    refetchCurrentLocation,
  }
}
